import { SET_INCIDENCIA } from '../constants/constants'

// eslint-disable-next-line default-param-last
const incidencia = (state = {}, action) => {
    if (action.type === SET_INCIDENCIA) {
        return action.payload
    }

    return state
}

export default incidencia
